<div class="d-flex flex-column">
  <app-arrow-circle
    direction="left"
    label="{{ 'common.back' | translate }}"
    [goTo]="backRoute"
  ></app-arrow-circle>
  <div class="layout-details-backdrop rounded-3"></div>
  <div class="layout-details-content w-100 row g-0 justify-content-center">
    <div class="col-12 col-md-10 px-2 px-md-0">
      <ng-content></ng-content>
    </div>
  </div>
</div>
